var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card-title",
            {
              staticClass: "pt-0"
            },
            [_vm._v(" " + _vm._s(_vm.$route.meta.pageTitle) + " ")]
          ),
          _c("profile-navigation"),
          _c("router-view")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }